import { useContext, useEffect, useState } from "react";
import MethodGet from "../../../config/Service";
import CartContext from "../../../Context/Cart/CartContext";
import Swal from "sweetalert2";
import showToast from "../../../utils/ShowToast";
import CurrencyFormat from "../../../utils/FormatCurrency";
import {
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Fade,
  Zoom,
  Paper,
  Badge,
} from "@mui/material";
import "./ProductDetails.css";

import {
  ShoppingCart,
  LocalOfferRounded,
  InventoryRounded,
  CategoryRounded,
  LabelRounded,
  ZoomInRounded,
  PlayCircleOutlineRounded,
} from "@mui/icons-material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/zoom";
import { Navigation, Thumbs, Zoom as SwiperZoom } from "swiper/modules";
import Spinner from "../../loading/Spinner";
import RelatedProductsSlider from "./RelatedProducts";
import SEO from "../../SEO/SEO";

export const ProductDetails = ({ id }) => {
  const defaultImage = require("../../../assets/img/default .png");
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const { cart, setCart } = useContext(CartContext);

  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState(null);
  const [randomProducts, setRandomProducts] = useState(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (id) {
      MethodGet(`/distribucion/products/${id}`)
        .then((res) => {
          setProduct(res.data.product);
          setRelatedProducts(res.data.relatedProducts);
          setRandomProducts(res.data.randomProducts);
        })
        .catch((error) =>
          console.error("Error al obtener la información del producto:", error)
        );
    }
  }, [id]);

  if (!product) return <Spinner />;

  const { img, category, subcategory, name, description, stock, price, videos, image } = product;

  // Combine media: Priority: 1. Cover Image, 2. Videos, 3. Remaining Images
  const mediaItems = [];
  
  if (image) {
    mediaItems.push({ type: 'image', url: image });
  }
  
  if (videos && videos.length > 0) {
    videos.forEach(v => mediaItems.push({ type: 'video', url: v.video }));
  }
  
  if (img && img.length > 0) {
    img.forEach(i => {
      if (i.image !== image) {
        mediaItems.push({ type: 'image', url: i.image });
      }
    });
  }

  const agregarProductsState = (prod) => {
    const maxStock = prod.stock || 0;
    Swal.fire({
      title: "",
      allowOutsideClick: false,
      html: `
        <div style="text-align:center;">
          <div style="background:linear-gradient(135deg,#801F56 0%,#D87390 100%);border-radius:12px;padding:16px 20px;margin-bottom:16px;">
            <p style="color:#fff;font-size:18px;font-weight:700;margin:0;">🛍️ Agregar al carrito</p>
            <p style="color:#F8BDD9;font-size:13px;margin:4px 0 0 0;">${prod.name}</p>
          </div>
          <div style="background:#FFF0F5;border-radius:10px;padding:12px;margin-bottom:14px;">
            <p style="color:#801F56;font-weight:600;font-size:14px;margin:0 0 4px 0;">Stock disponible</p>
            <span style="background:linear-gradient(135deg,#801F56,#E46EA7);color:#fff;padding:6px 18px;border-radius:20px;font-weight:700;font-size:16px;">${maxStock} piezas</span>
          </div>
          <label style="display:block;color:#2D1B30;font-weight:600;font-size:14px;margin-bottom:6px;text-align:left;">Cantidad deseada:</label>
          <input type="number" id="quantity" 
            style="width:100%;padding:12px 16px;border:2px solid #F3CDD4;border-radius:10px;font-size:16px;outline:none;transition:border 0.2s;box-sizing:border-box;"
            placeholder="Máximo ${maxStock} piezas" min="1" max="${maxStock}" 
            onfocus="this.style.borderColor='#801F56'" 
            onblur="this.style.borderColor='#F3CDD4'"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')">
        </div>
      `,
      showCancelButton: true,
      cancelButtonColor: "#9e9e9e",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Agregar al carrito",
      confirmButtonColor: "#801F56",
      focusConfirm: false,
      customClass: {
        popup: "swal2-rounded",
      },
      preConfirm: () => {
        const quantity = parseInt(
          Swal.getPopup().querySelector("#quantity").value,
          10
        );
        if (!quantity || quantity <= 0) {
          Swal.showValidationMessage("La cantidad debe ser mayor a 0");
          return false;
        }
        if (quantity > maxStock) {
          Swal.showValidationMessage(`Solo hay ${maxStock} piezas disponibles`);
          return false;
        }
        return { quantity };
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const quantityToAdd = result.value.quantity;
        const existingProductIndex = cart.findIndex(
          (item) => item.product_id === prod.id
        );

        let updatedCart = [...cart];

        if (existingProductIndex === -1) {
          const productoResultado = {
            product_id: prod.id,
            barcode: prod.tag,
            price: Number(prod.price),
            stock: prod.stock,
            name: prod.name,
            brand_id: prod.brand_id,
            cantidad: quantityToAdd,
            final_price: prod.price * quantityToAdd,
            image: prod?.img?.[0]?.image ?? prod.image ?? [],
          };
          if (productoResultado.cantidad > prod.stock) {
            showToast("warning", "¡Lo sentimos!", "El stock es insuficiente");
            return;
          }

          updatedCart = [productoResultado, ...cart];
        } else {
          const existingProduct = updatedCart[existingProductIndex];
          const newQuantity = Number(quantityToAdd);
          if (newQuantity > prod.stock) {
            showToast("warning", "¡Lo sentimos!", "El stock es insuficiente");
            return;
          }

          existingProduct.cantidad = newQuantity;
          existingProduct.final_price = newQuantity * existingProduct.price;
        }

        localStorage.setItem("cart", JSON.stringify(updatedCart));
        setCart(updatedCart);

        showToast(
          "success",
          "¡Agregado!",
          `${quantityToAdd} pieza${quantityToAdd > 1 ? "s" : ""} de ${prod.name}`
        );
      }
    });
  };

  const productoEnCarrito = cart.some((item) => item.product_id === product.id);

  const renderProductImages = () =>
    mediaItems.length > 0 ? (
      <Box>
        <Zoom in={true} timeout={600}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: "24px",
              overflow: "hidden",
              border: "3px solid #F0C9D5",
              backgroundColor: "#fff",
              padding: 2,
            }}
          >
            <Swiper
              modules={[Navigation, Thumbs, SwiperZoom]}
              navigation
              zoom={true}
              thumbs={{ swiper: thumbsSwiper }}
              style={{
                borderRadius: "16px",
                "--swiper-navigation-color": "#9A457F",
                "--swiper-navigation-size": "32px",
              }}
            >
              {mediaItems.map((media, index) => (
                <SwiperSlide key={index}>
                  {media.type === 'video' ? (
                    <Box
                      sx={{
                        position: 'relative',
                        width: '100%',
                        height: '500px',
                        backgroundColor: '#000',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <video
                        src={media.url}
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          position: 'absolute',
                          bottom: 20,
                          left: 20,
                          color: 'white',
                          fontWeight: 'bold',
                          textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                          zIndex: 10,
                          backgroundColor: 'rgba(0,0,0,0.3)',
                          padding: '4px 12px',
                          borderRadius: '8px',
                        }}
                      >
                        @Merrycolor
                      </Typography>
                    </Box>
                  ) : (
                    <div className="swiper-zoom-container">
                      <img
                        src={media.url}
                        alt={name}
                        style={{
                          width: "100%",
                          height: "auto",
                          maxHeight: "500px",
                          objectFit: "contain",
                          borderRadius: "12px",
                        }}
                      />
                    </div>
                  )}
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Thumbnails */}
            <Box sx={{ mt: 2 }}>
              <Swiper
                onSwiper={setThumbsSwiper}
                spaceBetween={10}
                slidesPerView={4}
                watchSlidesProgress
                style={{ padding: "8px 0" }}
              >
                {mediaItems.map((media, index) => (
                  <SwiperSlide key={index}>
                    {media.type === 'video' ? (
                      <Box
                        sx={{
                          width: "100%",
                          height: "80px",
                          borderRadius: "12px",
                          border: "2px solid #F0C9D5",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          overflow: "hidden",
                          position: "relative",
                          backgroundColor: "#f5f5f5",
                          '&:hover': {
                            borderColor: "#9A457F",
                            transform: "scale(1.05)",
                          }
                        }}
                      >
                        <video src={media.url} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.6 }} />
                        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <PlayCircleOutlineRounded sx={{ fontSize: 32, color: '#9A457F' }} />
                        </Box>
                      </Box>
                    ) : (
                      <img
                        src={media.url}
                        alt={`Thumbnail ${index}`}
                        style={{
                          width: "100%",
                          height: "80px",
                          objectFit: "cover",
                          borderRadius: "12px",
                          border: "2px solid #F0C9D5",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.borderColor = "#9A457F";
                          e.target.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.borderColor = "#F0C9D5";
                          e.target.style.transform = "scale(1)";
                        }}
                      />
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>
            </Box>
          </Paper>
        </Zoom>
      </Box>
    ) : (
      <Zoom in={true} timeout={600}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: "24px",
            overflow: "hidden",
            border: "3px solid #F0C9D5",
            backgroundColor: "#fff",
            padding: 4,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={defaultImage}
            alt="Imagen por defecto"
            style={{
              width: "70%",
              maxWidth: "400px",
              borderRadius: "16px",
            }}
          />
        </Paper>
      </Zoom>
    );

  const renderProductSection = (label, products) => (
    <Box sx={{ mt: 6 }}>
      <Divider>
        <Chip
          label={label}
          sx={{
            p: 2.5,
            mb: 3,
            mt: 3,
            fontWeight: 800,
            fontSize: "1.1rem",
            background: "linear-gradient(135deg, #9A457F 0%, #D87390 100%)",
            color: "white",
            boxShadow: "0 4px 16px rgba(154, 69, 127, 0.3)",
          }}
        />
      </Divider>
      <Box sx={{ mb: 5 }}>
        <RelatedProductsSlider relatedProducts={products} />
      </Box>
    </Box>
  );

  return (
    <>
      <SEO
        title={name}
        description={description ? description.substring(0, 160) : "Comprar en MerryColor"}
        image={img && img.length > 0 ? img[0].image : null}
        url={`/product/${id}`}
        price={product.price_with_discount || price}
        availability={stock > 0 ? 'instock' : 'outofstock'}
      />
      <Box
        sx={{
          padding: { xs: 3, md: 5 },
          background: "linear-gradient(180deg, #FBFAFF 0%, #FFF5F8 100%)",
          minHeight: "100vh",
        }}
      >
        <Grid container spacing={4}>
          {/* Image Gallery */}
          <Grid item xs={12} md={6}>
            {renderProductImages()}
          </Grid>

          {/* Product Info */}
          <Grid item xs={12} md={6}>
            <Fade in={true} timeout={800}>
              <Paper
                elevation={0}
                sx={{
                  padding: { xs: 3, md: 4 },
                  borderRadius: "24px",
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(10px)",
                  border: "2px solid rgba(216, 115, 144, 0.2)",
                  boxShadow: "0 8px 32px rgba(154, 69, 127, 0.1)",
                }}
              >
                {/* Product Name */}
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 800,
                    mb: 2,
                    fontSize: { xs: "1.75rem", md: "2.5rem" },
                    background: "linear-gradient(135deg, #801F56 0%, #D87390 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    lineHeight: 1.2,
                  }}
                >
                  {name}
                </Typography>

                {/* Stock Badge */}
                <Box sx={{ mb: 3 }}>
                  <Chip
                    icon={<InventoryRounded />}
                    label={stock > 0 ? `${stock} disponibles` : "Sin stock"}
                    sx={{
                      fontWeight: 700,
                      fontSize: "1rem",
                      padding: "20px 16px",
                      background: stock > 0
                        ? "linear-gradient(135deg, #4CAF50 0%, #81C784 100%)"
                        : "linear-gradient(135deg, #f44336 0%, #e57373 100%)",
                      color: "#fff",
                      boxShadow: stock > 0
                        ? "0 4px 12px rgba(76, 175, 80, 0.3)"
                        : "0 4px 12px rgba(244, 67, 54, 0.3)",
                      "& .MuiChip-icon": {
                        color: "#fff",
                      },
                    }}
                  />
                </Box>

                {/* Price */}
                <Box sx={{ mb: 3 }}>
                  {product.price_with_discount ? (
                    <Box>
                      <Typography
                        variant="h5"
                        sx={{
                          textDecoration: "line-through",
                          color: "#999",
                          fontWeight: 600,
                          mb: 0.5,
                        }}
                      >
                        {CurrencyFormat(price)}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Typography
                          variant="h3"
                          sx={{
                            fontWeight: 900,
                            color: "#9A457F",
                            fontSize: { xs: "2rem", md: "3rem" },
                          }}
                        >
                          {CurrencyFormat(product.price_with_discount)}
                        </Typography>
                        <Chip
                          icon={<LocalOfferRounded />}
                          label="OFERTA"
                          sx={{
                            background: "linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)",
                            color: "#fff",
                            fontWeight: 800,
                            fontSize: "0.9rem",
                            boxShadow: "0 4px 12px rgba(255, 107, 107, 0.3)",
                            "& .MuiChip-icon": {
                              color: "#fff",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 900,
                        color: "#9A457F",
                        fontSize: { xs: "2rem", md: "3rem" },
                      }}
                    >
                      {CurrencyFormat(price)}
                    </Typography>
                  )}
                </Box>

                <Divider sx={{ my: 3, borderColor: "#F0C9D5" }} />

                {/* Category & Subcategory */}
                <Box sx={{ mb: 3, display: "flex", flexDirection: "column", gap: 1.5 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <CategoryRounded sx={{ color: "#9A457F", fontSize: 24 }} />
                    <Typography sx={{ fontWeight: 600, color: "#555", fontSize: "1rem" }}>
                      Categoría:
                    </Typography>
                    <Chip
                      label={category?.name}
                      sx={{
                        fontWeight: 700,
                        backgroundColor: "#FFF5F8",
                        color: "#801F56",
                        border: "2px solid #F0C9D5",
                      }}
                    />
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <LabelRounded sx={{ color: "#9A457F", fontSize: 24 }} />
                    <Typography sx={{ fontWeight: 600, color: "#555", fontSize: "1rem" }}>
                      Subcategoría:
                    </Typography>
                    <Chip
                      label={subcategory?.name}
                      sx={{
                        fontWeight: 700,
                        backgroundColor: "#FFF5F8",
                        color: "#801F56",
                        border: "2px solid #F0C9D5",
                      }}
                    />
                  </Box>
                </Box>

                {/* Description */}
                {description && (
                  <>
                    <Divider sx={{ my: 3, borderColor: "#F0C9D5" }} />
                    <Typography
                      sx={{
                        mb: 3,
                        color: "#666",
                        fontSize: "1.05rem",
                        lineHeight: 1.7,
                      }}
                    >
                      {description}
                    </Typography>
                  </>
                )}

                <Divider sx={{ my: 3, borderColor: "#F0C9D5" }} />

                {/* Add to Cart Button */}
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<ShoppingCart />}
                  onClick={() => agregarProductsState(product)}
                  sx={{
                    borderRadius: "16px",
                    padding: "16px 32px",
                    fontSize: "1.1rem",
                    fontWeight: 800,
                    textTransform: "none",
                    background: productoEnCarrito
                      ? "linear-gradient(135deg, #9A457F 0%, #D87390 100%)"
                      : "linear-gradient(135deg, #D87390 0%, #FAA5B7 100%)",
                    boxShadow: productoEnCarrito
                      ? "0 8px 24px rgba(154, 69, 127, 0.4)"
                      : "0 8px 24px rgba(216, 115, 144, 0.4)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: productoEnCarrito
                        ? "linear-gradient(135deg, #801F56 0%, #9A457F 100%)"
                        : "linear-gradient(135deg, #9A457F 0%, #D87390 100%)",
                      transform: "translateY(-4px)",
                      boxShadow: productoEnCarrito
                        ? "0 12px 32px rgba(154, 69, 127, 0.5)"
                        : "0 12px 32px rgba(216, 115, 144, 0.5)",
                    },
                    "&:active": {
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  {productoEnCarrito ? "Modificar cantidad" : "Agregar al carrito"}
                </Button>
              </Paper>
            </Fade>
          </Grid>
        </Grid>

        {/* Related Products */}
        {renderProductSection("Productos Relacionados", relatedProducts)}
        {renderProductSection("Podrían interesarte", randomProducts)}
      </Box>
    </>
  );
};
